module.exports = __webpack_public_path__ + "708d5be7ea68b3431468549df1a77746.MP3";